import React from 'react';
import { Card, Row, Col, Form } from 'react-bootstrap';

const HeaderFiltrosBorrado = ({
    estatusBorrado,
    handleCambiarEstatusBorrado,
    tipoLicencia,
    handleCambiarTipoLicencia,
    mesesVencimiento,
    handleCambiarMeses,
    busqueda,
    handleCambiarBusqueda,
    handleLimpiarBusqueda,
    conteoTabs,
    cargando,
    children
}) => (
    <Card className="mb-3 bg-white border border-200 shadow-sm">
        <Card.Body className="p-3 p-md-4">
           
            {/* Título y Acciones Superiores */}
            <Row className="align-items-center justify-content-between mb-4 gy-3">
                <Col md lg>
                    <h5 className="fw-bolder text-900 mb-1" style={{ letterSpacing: '-0.3px', fontSize: '1.45rem' }}>
                        Mantenimiento de Borrado de Licencias
                    </h5>
                    <p className="text-600 mb-0 fs--1" style={{ maxWidth: '680px', lineHeight: 1.5 }}>
                        Consulta y programa la eliminación de licencias vencidas de empresas inactivas. Libera espacio y cumple con las normativas de retención de datos.
                    </p>
                </Col>
                <Col md="auto" lg="auto" className="d-flex justify-content-end align-items-center gap-2 flex-nowrap">
                    {children}
                </Col>
            </Row>

            {/* Pestañas de Navegación con Conteo */}
            <div className="d-flex align-items-center gap-4 border-bottom mb-3 overflow-auto" style={{ borderBottomColor: '#e9edf4' }}>
                <div 
                    className={`d-flex align-items-center pb-2 cursor-pointer text-nowrap user-select-none ${estatusBorrado === 0 ? 'text-primary fw-bold' : 'text-600 fw-semi-bold'}`}
                    style={{ 
                        cursor: cargando ? 'not-allowed' : 'pointer',
                        borderBottom: estatusBorrado === 0 ? '2.5px solid #2c7be5' : '2.5px solid transparent',
                        marginBottom: '-1px',
                        transition: 'all 0.2s ease-in-out'
                    }}
                    onClick={() => !cargando && handleCambiarEstatusBorrado(0)}
                >
                    <span className="fs--1">Pendientes por Programar</span>
                    <span className={`badge rounded-pill ms-2 px-2 py-1 fs--2 ${estatusBorrado === 0 ? 'bg-soft-primary text-primary' : 'bg-200 text-700'}`}>
                        {conteoTabs?.[0] ?? 0}
                    </span>
                </div>

                <div 
                    className={`d-flex align-items-center pb-2 cursor-pointer text-nowrap user-select-none ${estatusBorrado === 1 ? 'text-primary fw-bold' : 'text-600 fw-semi-bold'}`}
                    style={{ 
                        cursor: cargando ? 'not-allowed' : 'pointer',
                        borderBottom: estatusBorrado === 1 ? '2.5px solid #2c7be5' : '2.5px solid transparent',
                        marginBottom: '-1px',
                        transition: 'all 0.2s ease-in-out'
                    }}
                    onClick={() => !cargando && handleCambiarEstatusBorrado(1)}
                >
                    <span className="fs--1">Ya Programadas</span>
                    <span className="badge rounded-pill bg-soft-primary text-primary ms-2 px-2 py-1 fs--2">
                        {conteoTabs?.[1] ?? 0}
                    </span>
                </div>

                <div 
                    className={`d-flex align-items-center pb-2 cursor-pointer text-nowrap user-select-none ${estatusBorrado === 2 ? 'text-primary fw-bold' : 'text-600 fw-semi-bold'}`}
                    style={{ 
                        cursor: cargando ? 'not-allowed' : 'pointer',
                        borderBottom: estatusBorrado === 2 ? '2.5px solid #2c7be5' : '2.5px solid transparent',
                        marginBottom: '-1px',
                        transition: 'all 0.2s ease-in-out'
                    }}
                    onClick={() => !cargando && handleCambiarEstatusBorrado(2)}
                >
                    <span className="fs--1">No Borradas / Omitidas</span>
                    <span className="badge rounded-pill bg-soft-warning text-warning ms-2 px-2 py-1 fs--2">
                        {conteoTabs?.[2] ?? 0}
                    </span>
                </div>

                <div 
                    className={`d-flex align-items-center pb-2 cursor-pointer text-nowrap user-select-none ${estatusBorrado === 3 ? 'text-primary fw-bold' : 'text-600 fw-semi-bold'}`}
                    style={{ 
                        cursor: cargando ? 'not-allowed' : 'pointer',
                        borderBottom: estatusBorrado === 3 ? '2.5px solid #2c7be5' : '2.5px solid transparent',
                        marginBottom: '-1px',
                        transition: 'all 0.2s ease-in-out'
                    }}
                    onClick={() => !cargando && handleCambiarEstatusBorrado(3)}
                >
                    <span className="fs--1">Borradas Exitosamente</span>
                    <span className="badge rounded-pill bg-soft-success text-success ms-2 px-2 py-1 fs--2">
                        {conteoTabs?.[3] ?? 0}
                    </span>
                </div>
            </div>

            {/* Barra de Búsqueda y Filtros de Selección */}
            <Row className="align-items-center justify-content-between g-3 pt-1">
                {/* Buscador de Empresa o ID */}
                <Col md={6} lg={4}>
                    <div className="position-relative">
                        <i 
                            className="fas fa-search position-absolute top-50 translate-middle-y text-400 ms-3" 
                            style={{ pointerEvents: 'none', fontSize: '0.85rem' }}
                        ></i>
                        <Form.Control
                            type="text"
                            size="sm"
                            placeholder="Buscar por empresa o ID de licencia..."
                            value={busqueda}
                            onChange={handleCambiarBusqueda}
                            className="ps-5 bg-white border-300"
                            style={{ borderRadius: '8px', height: '38px', fontSize: '0.85rem' }}
                        />
                        {busqueda && (
                            <button
                                type="button"
                                className="btn btn-link position-absolute end-0 top-50 translate-middle-y text-400 p-0 me-2"
                                onClick={handleLimpiarBusqueda}
                                style={{ textDecoration: 'none' }}
                                title="Limpiar búsqueda"
                            >
                                <i className="fas fa-times-circle"></i>
                            </button>
                        )}
                    </div>
                </Col>

                {/* Filtros Dropdowns (Sin botón de reiniciar por solicitud) */}
                <Col md={6} lg={8}>
                    <div className="d-flex justify-content-md-end gap-3 flex-wrap align-items-center">
                        <div className="d-flex align-items-center gap-2">
                            <span className="fs--1 text-700 fw-semi-bold text-nowrap">Licencia:</span>
                            <Form.Select
                                size="sm"
                                style={{ width: 'auto', minWidth: '170px', borderRadius: '8px', height: '38px', fontSize: '0.85rem' }}
                                value={tipoLicencia}
                                onChange={handleCambiarTipoLicencia}
                                className="bg-white border-300"
                            >
                                <option value="Todos">Todas las Licencias</option>
                                <option value="Nube">Solo Nube</option>
                                <option value="AkasiaPOS">Solo AkasiaPOS</option>
                                <option value="Ambas">Empresas con Ambas</option>
                            </Form.Select>
                        </div>
                        <div className="d-flex align-items-center gap-2">
                            <span className="fs--1 text-700 fw-semi-bold text-nowrap">Vencimiento:</span>
                            <Form.Select
                                size="sm"
                                style={{ width: 'auto', minWidth: '170px', borderRadius: '8px', height: '38px', fontSize: '0.85rem' }}
                                value={mesesVencimiento}
                                onChange={handleCambiarMeses}
                                className="bg-white border-300"
                            >
                                <option value={-3}>&lt; 3 Meses Vencida</option>
                                <option value={1}>&ge; 1 Mes Vencida</option>
                                <option value={2}>&ge; 2 Meses Vencida</option>
                                <option value={3}>&ge; 3 Meses Vencida</option>
                                <option value={6}>&ge; 6 Meses Vencida</option>
                                <option value={12}>&ge; 12 Meses Vencida</option>
                            </Form.Select>
                        </div>
                    </div>
                </Col>
            </Row>
        </Card.Body>
    </Card>
);

export default HeaderFiltrosBorrado;
